// extracted by mini-css-extract-plugin
module.exports = {"center_like_parent":"grey_import_info__center_like_parent__BpMAx"};